(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lcd-product-details"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.dataset.lcdInitialized) return;
    var tabs = Array.from(root.querySelectorAll('[data-lcd-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-lcd-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    root.dataset.lcdInitialized = 'true';
    if (root.hasAttribute('data-lcd-merge-facts')) {
      var factsSlot = root.querySelector('[data-lcd-facts-slot]');
      var main = root.closest('main, .main-content') || document;
      var facts = Array.from(main.querySelectorAll('.lcd-product-facts')).find(function (item) {
        return !item.closest('[data-lcd-product-details]');
      });
      if (factsSlot && facts) factsSlot.appendChild(facts);
    }
    var media = window.matchMedia('(min-width: 780px)');
    var preferred = panels.find(function (panel) { return panel.dataset.lcdDefault === 'true'; }) || panels[0];
    var selected = preferred.dataset.lcdPanel;
    var tablist = root.querySelector('[data-lcd-tabs]');
    function select(id, focus) {
      selected = id;
      tabs.forEach(function (tab) {
        var active = tab.dataset.lcdTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.lcdPanel === id;
        panel.hidden = !active;
        panel.open = active;
      });
    }
    function applyMode() {
      if (media.matches) {
        tablist.setAttribute('role', 'tablist');
        tabs.forEach(function (tab) {
          tab.setAttribute('role', 'tab');
          var panel = panels.find(function (item) { return item.dataset.lcdPanel === tab.dataset.lcdTab; });
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
        });
        select(selected, false);
      } else {
        tablist.removeAttribute('role');
        panels.forEach(function (panel) {
          panel.hidden = false;
          panel.open = panel === preferred;
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        });
      }
      root.classList.add('is-ready');
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        if (media.matches) select(tab.dataset.lcdTab, false);
      });
      tab.addEventListener('keydown', function (event) {
        if (!media.matches) return;
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[next].dataset.lcdTab, true);
      });
    });
    media.addEventListener('change', applyMode);
    applyMode();
  }
  function mount(scope) {
    scope.querySelectorAll('[data-lcd-product-details]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lcd-purchase-quantity"] && !Shopify.designMode) return;
  try {
    (function () {
  function syncSticky(section, source) {
    if (!section) return;
    var quantity = section.querySelector('.lcd-purchase-quantity input[name="quantity"]');
    if (!quantity) return;
    if (source && source !== quantity) quantity.value = source.value;
    if (!quantity.validity.valid) return;
    section.querySelectorAll('sticky-atc input[name="quantity"]').forEach(function (input) {
      input.value = quantity.value;
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('.lcd-purchase-quantity input[name="quantity"]')) {
      syncSticky(event.target.closest('.shopify-section'), event.target);
    }
  });
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
    var section = event.target.closest('.shopify-section');
    var quantity = section && section.querySelector('.lcd-purchase-quantity input[name="quantity"]');
    if (!quantity) return;
    if (!quantity.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      quantity.reportValidity();
      return;
    }
    syncSticky(section);
  }, true);
})();
(function () {
  function prepareSticky(sticky) {
    var form = sticky.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;
    var select = sticky.querySelector('select[name="id"]');
    var id = form.querySelector('input[name="id"]');
    if (select && id) {
      var option = select.options[select.selectedIndex];
      if (!option || option.disabled || !select.value) return null;
      id.value = select.value;
    }
    if (!id || !id.value) return null;
    return form;
  }
  document.addEventListener('change', function (event) {
    if (!event.target.matches('sticky-atc select[name="id"]')) return;
    prepareSticky(event.target.closest('sticky-atc'));
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('sticky-atc button[name="add"]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = prepareSticky(button.closest('sticky-atc'));
    if (!form) return;
    // Submit through the theme so its cart drawer and validation still run.
    button.type = 'submit';
    form.requestSubmit(button);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lcd-storefront-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const close = event.target.closest('.minicart-close[role="button"]');
    if (!close || event.target !== close) return;
    event.preventDefault();
    close.click();
  });

  document.addEventListener('click', function (event) {
    const link = event.target.closest('.lcd-product-links a[href^="#lcd-description-"]');
    if (!link) return;
    const details = document.getElementById(link.hash.slice(1));
    if (details && details.tagName === 'DETAILS') details.open = true;
  });

(function () {
  if (window.lcdCardZoomGlobalReady) return;
  window.lcdCardZoomGlobalReady = true;
  var dialog;
  var trigger;
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-lcd-card-zoom]');
    if (!link) return;
    if (!dialog) {
      dialog = document.createElement('dialog');
      if (typeof dialog.showModal !== 'function') return;
      dialog.className = 'lcd-card-zoom-dialog';
      var close = document.createElement('button');
      close.type = 'button';
      close.textContent = '×';
      close.addEventListener('click', function () { dialog.close(); });
      dialog.appendChild(close);
      dialog.appendChild(document.createElement('img'));
      dialog.appendChild(document.createElement('a'));
      dialog.addEventListener('click', function (click) {
        if (click.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        if (trigger && trigger.isConnected) trigger.focus();
      });
      document.body.appendChild(dialog);
    }
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger = link;
    dialog.setAttribute('aria-label', link.dataset.productTitle);
    dialog.querySelector('button').setAttribute('aria-label', link.dataset.closeLabel);
    var image = dialog.querySelector('img');
    image.src = link.href;
    image.alt = link.dataset.productTitle;
    var productLink = dialog.querySelector('a');
    productLink.href = link.dataset.productUrl;
    productLink.textContent = link.dataset.productLabel;
    if (!dialog.open) dialog.showModal();
  }, true);
})();



(function () {
  var root = document.documentElement;
  var frame = 0;
  var lastBottom = '';
  var shadowStyles = '#app-embed[class*="RootTeaser"] { bottom: var(--lcd-mobile-float-bottom, 12px) !important; left: 0 !important; right: auto !important; }';
  var observedSticky = new WeakSet();
  var sizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  var stickyObserver = new MutationObserver(schedule);

  function installFormStyles() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      var shadow = host.shadowRoot;
      if (!shadow || shadow.querySelector('[data-lcd-floating-spacing]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-lcd-floating-spacing', '');
      style.textContent = shadowStyles;
      shadow.appendChild(style);
    });
  }

  function update() {
    frame = 0;
    var height = 0;
    document.querySelectorAll('sticky-atc').forEach(function (sticky) {
      if (!observedSticky.has(sticky)) {
        observedSticky.add(sticky);
        if (sizeObserver) sizeObserver.observe(sticky);
        stickyObserver.observe(sticky, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
      if (!sticky.classList.contains('active')) return;
      var box = sticky.getBoundingClientRect();
      var computed = getComputedStyle(sticky);
      if (computed.display === 'none' || computed.visibility === 'hidden' || box.height <= 0 || box.top >= window.innerHeight || box.bottom <= 0) return;
      height = Math.max(height, Math.min(window.innerHeight, window.innerHeight - Math.max(0, box.top)));
    });
    var bottom = Math.ceil(height + 12) + 'px';
    if (bottom !== lastBottom) {
      root.style.setProperty('--lcd-mobile-float-bottom', bottom);
      lastBottom = bottom;
    }
    installFormStyles();
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  var bodyObserver = new MutationObserver(schedule);
  bodyObserver.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
  if (window.customElements) customElements.whenDefined('shopify-forms-embed').then(schedule);
  var attempts = 0;
  var retry = setInterval(function () {
    schedule();
    attempts++;
    if (attempts >= 30) clearInterval(retry);
  }, 500);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lcd-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.getElementById('lcd-wishlist-root');
    const dialog = document.getElementById('lcd-wishlist-dialog');
    if (!root || !dialog || root.dataset.initialized || typeof dialog.showModal !== 'function') return;
    root.dataset.initialized = 'true';
    const key = 'lcd:wishlist:v1';
    const list = root.querySelector('[data-lcd-wishlist-list]');
    const empty = root.querySelector('[data-lcd-wishlist-empty]');
    const status = root.querySelector('[data-lcd-wishlist-status]');
    let timer;
    let opener;
    const safeItem = (item) => {
      if (!item || typeof item.handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(item.handle)) return null;
      if (typeof item.title !== 'string' || typeof item.url !== 'string') return null;
      try {
        const url = new URL(item.url, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.endsWith('/products/' + item.handle)) return null;
        let image = '';
        if (typeof item.image === 'string' && item.image) {
          const candidate = new URL(item.image, window.location.origin);
          if (candidate.protocol === 'https:' && (candidate.hostname === window.location.hostname || candidate.hostname === 'cdn.shopify.com' || candidate.hostname.endsWith('.myshopify.com'))) image = candidate.href;
        }
        return {handle: item.handle, title: item.title.slice(0, 300), url: url.pathname, image};
      } catch { return null; }
    };
    const read = () => {
      const raw = localStorage.getItem(key);
      if (!raw) return [];
      let parsed;
      try { parsed = JSON.parse(raw); } catch { return []; }
      if (!Array.isArray(parsed)) return [];
      const seen = new Set();
      return parsed.map(safeItem).filter(item => {
        if (!item || seen.has(item.handle)) return false;
        seen.add(item.handle);
        return true;
      }).slice(0, 100);
    };
    const announce = (message) => {
      clearTimeout(timer);
      status.textContent = message;
      status.hidden = false;
      timer = setTimeout(() => { status.hidden = true; }, 6500);
    };
    const paint = (items) => {
      document.querySelectorAll('[data-lcd-wishlist-toggle]').forEach(button => {
        const saved = items.some(item => item.handle === button.dataset.handle);
        button.setAttribute('aria-pressed', String(saved));
        const label = button.querySelector('[data-lcd-wishlist-label]');
        if (label) label.textContent = saved ? root.dataset.saved : root.dataset.add;
      });
      document.querySelectorAll('[data-lcd-wishlist-count]').forEach(count => {
        count.textContent = String(items.length);
        count.hidden = items.length === 0;
      });
      empty.hidden = items.length > 0;
      list.replaceChildren();
      items.forEach(item => {
        const card = document.createElement('li');
        card.className = 'lcd-wishlist-card';
        const imageLink = document.createElement('a');
        imageLink.href = item.url;
        imageLink.setAttribute('aria-label', item.title);
        if (item.image) {
          const image = document.createElement('img');
          image.className = 'lcd-wishlist-card__image';
          image.src = item.image;
          image.alt = '';
          image.width = 76;
          image.height = 90;
          image.loading = 'lazy';
          imageLink.append(image);
        }
        const copy = document.createElement('div');
        copy.className = 'lcd-wishlist-card__copy';
        const title = document.createElement('a');
        title.className = 'lcd-wishlist-card__title';
        title.href = item.url;
        title.textContent = item.title;
        const actions = document.createElement('div');
        actions.className = 'lcd-wishlist-card__actions';
        const view = document.createElement('a');
        view.href = item.url;
        view.textContent = root.dataset.view;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.lcdWishlistRemove = item.handle;
        remove.textContent = root.dataset.remove;
        remove.setAttribute('aria-label', root.dataset.remove + ' : ' + item.title);
        actions.append(view, remove);
        copy.append(title, actions);
        card.append(imageLink, copy);
        list.append(card);
      });
    };
    const refresh = () => {
      try { paint(read()); } catch { paint([]); }
    };
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-lcd-wishlist-toggle], [data-lcd-wishlist-open], [data-lcd-wishlist-close], [data-lcd-wishlist-remove]');
      if (!button) return;
      event.preventDefault();
      if (button.hasAttribute('data-lcd-wishlist-close')) { dialog.close(); return; }
      if (button.hasAttribute('data-lcd-wishlist-open')) {
        refresh();
        opener = button;
        if (!dialog.open) dialog.showModal();
        return;
      }
      try {
        let items = read();
        const handle = button.dataset.lcdWishlistRemove || button.dataset.handle;
        const existed = items.some(item => item.handle === handle);
        if (existed) {
          items = items.filter(item => item.handle !== handle);
        } else if (button.hasAttribute('data-lcd-wishlist-toggle')) {
          const item = safeItem(button.dataset);
          if (!item) return;
          if (items.length >= 100) { announce(root.dataset.limit); return; }
          items.push(item);
        } else { return; }
        localStorage.setItem(key, JSON.stringify(items));
        paint(items);
        announce(existed ? root.dataset.removedMessage : root.dataset.addedMessage);
        if (dialog.open && button.hasAttribute('data-lcd-wishlist-remove')) {
          const next = list.querySelector('[data-lcd-wishlist-remove]');
          (next || root.querySelector('[data-lcd-wishlist-close]')).focus();
        }
      } catch { announce(root.dataset.error); }
    });
    dialog.addEventListener('close', () => {
      if (opener && opener.isConnected) opener.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    window.addEventListener('storage', event => { if (event.key === key || event.key === null) refresh(); });
    document.addEventListener('shopify:section:load', refresh);
    refresh();
    document.documentElement.classList.add('lcd-wishlist-ready');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  var dialog;
  var trigger;
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-lcd-card-zoom]');
    if (!link) return;
    if (!dialog) {
      dialog = document.createElement('dialog');
      if (typeof dialog.showModal !== 'function') return;
      dialog.className = 'lcd-card-zoom-dialog';
      var close = document.createElement('button');
      close.type = 'button';
      close.textContent = '×';
      close.addEventListener('click', function () { dialog.close(); });
      dialog.appendChild(close);
      dialog.appendChild(document.createElement('img'));
      dialog.appendChild(document.createElement('a'));
      dialog.addEventListener('click', function (click) {
        if (click.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        if (trigger && trigger.isConnected) trigger.focus();
      });
      document.body.appendChild(dialog);
    }
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    trigger = link;
    dialog.setAttribute('aria-label', link.dataset.productTitle);
    dialog.querySelector('button').setAttribute('aria-label', link.dataset.closeLabel);
    var image = dialog.querySelector('img');
    image.src = link.href;
    image.alt = link.dataset.productTitle;
    var productLink = dialog.querySelector('a');
    productLink.href = link.dataset.productUrl;
    productLink.textContent = link.dataset.productLabel;
    if (!dialog.open) dialog.showModal();
  });
})();



(() => {
  const desktopHover = window.matchMedia('(min-width: 780px) and (hover: hover) and (pointer: fine)');
  function loadHoverImage(event) {
    if (!desktopHover.matches || event.pointerType === 'touch') return;
    const card = event.target.closest('.lcd-hover-card');
    if (!card) return;
    const image = card.querySelector('img[data-lcd-hover-src]');
    if (!image || image.dataset.lcdHoverLoading) return;
    const wrapper = image.closest('.media-hover');
    image.dataset.lcdHoverLoading = 'true';
    function cleanup() {
      image.removeEventListener('load', ready);
      image.removeEventListener('error', failed);
      delete image.dataset.lcdHoverLoading;
    }
    function ready() {
      if (image.naturalWidth <= 1) return;
      if (wrapper) wrapper.classList.add('lcd-hover-ready');
      delete image.dataset.lcdHoverSrc;
      delete image.dataset.lcdHoverSrcset;
      cleanup();
    }
    function failed() {
      cleanup();
      image.removeAttribute('srcset');
      image.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    }
    image.addEventListener('load', ready);
    image.addEventListener('error', failed);
    image.loading = 'eager';
    image.decoding = 'async';
    if (image.dataset.lcdHoverSrcset) image.srcset = image.dataset.lcdHoverSrcset;
    image.src = image.dataset.lcdHoverSrc;
    if (image.complete && image.naturalWidth > 1) ready();
  }
  document.addEventListener('pointerover', loadHoverImage, { passive: true });
  document.addEventListener('focusin', loadHoverImage);
})();
  } catch(e) { console.error(e); }
})();

})();
